import { Component, type ErrorInfo, type ReactNode } from 'react';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  failed: boolean;
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ScreenGrid Generator render error', error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-error" role="alert">
        <div>
          <strong>ScreenGrid Generator could not render the current state.</strong>
          <p>Reload the application to continue with the last valid saved settings.</p>
          <button
            type="button"
            className="button button--primary"
            onClick={() => location.reload()}
          >
            Reload application
          </button>
        </div>
      </main>
    );
  }
}
